module.exports = __webpack_public_path__ + "media/images/svgs/exclamation_sign-288d0cd39994ae47e78be3449257af3e.svg";